// extracted by mini-css-extract-plugin
export default {"header":"style_header__No4-7"};